export const AvatarBadge = () => import("./AvatarBadge.vue");
export const GoogleMap = () => import("./GoogleMap/GoogleMap.vue");
export * from './FloatingActionButton';